export default {
  computed: {
    step() {
      return this.$route.params.step ?? this.steps[0].value
    },
    stepIndex() {
      return this.steps.findIndex(item => item.value == this.step)
    },
    isStepAsmenys() {
      return this.step == 'asmenys'
    },
    isStepTurtas() {
      return this.step == 'turtas'
    },
    isStepSutartis() {
      return this.step == 'sutartis'
    },
    isStepDuomenys() {
      return this.step == 'duomenys'
    },
    isStepRegistravimas() {
      return this.step == 'registravimas'
    },
  },
  methods: {
    gotoStep(newStep) {
      this.$router.push({
        name: this.stepRouteName,
        params: {
          ...this.$route.params,
          step: newStep,
        },
      })
    },
    gotoNextStep() {
      if (this.stepIndex < this.steps.length - 1) {
        this.gotoStep(this.steps[this.stepIndex + 1].value)
      }
    },
    gotoPrevStep() {
      if (this.stepIndex > 0) {
        this.gotoStep(this.steps[this.stepIndex - 1].value)
      }
    },
    gotoAsmenys() {
      this.gotoStep(this.steps[0].value)
    },
  },
}
